export enum InquiryWeddingDeliveryType {
	DeliveryToAddress = "DeliveryToAddress",
	PickUpUndecided = "PickUpUndecided",
	PickUpCakovice = "PickUpCakovice",
	PickUpPetriny = "PickUpPetriny",
	PickUpCentral = "PickUpCentral",
}
